import { useState } from 'react';
import { Button, Paper, Stack, Text } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { DeleteOrganizationModal } from './delete-organization-modal';

export function DeleteOrganizationPanel({
  organizationId,
  organizationName,
}: {
  organizationId: string;
  organizationName: string;
}) {
  const navigate = useNavigate();
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Paper p="md" withBorder radius="md">
        <Stack gap="sm">
          <Text fw={600} c="red.6" size="sm">
            Danger Zone
          </Text>
          <Text size="sm" c="dimmed">
            Deleting this organization removes all members and cannot be undone. Organizations with phone numbers or
            flows cannot be deleted.
          </Text>
          <div>
            <Button variant="outline" color="red" onClick={() => setOpened(true)}>
              Delete Organization
            </Button>
          </div>
        </Stack>
      </Paper>

      {opened && (
        <DeleteOrganizationModal
          organizationId={organizationId}
          organizationName={organizationName}
          onClose={() => setOpened(false)}
          onDeleted={() => void navigate({ to: '/system/organizations' })}
        />
      )}
    </>
  );
}
